import {useCallback, useEffect, useState} from "react";
import {useSnackbarContext} from "../../common/Snackbar";
import {findHubById} from "../../../api/HubApi";

export default function UseHubMetricsExport({hubId}) {
    const [hub, setHub] = useState(undefined);
    const [hubLoading, setHubLoading] = useState(true);

    const {handleMessageUpdate} = useSnackbarContext();

    function handleApiError(error) {
        handleMessageUpdate(`${error.message} [${error.code}]`);
    }

    const handleErrorCallback = useCallback(handleApiError, []);

    useEffect(() => {
        function handleHubChanged(hub) {
            setHub(hub);
        }

        function handleHubLoadingChanged(value) {
            setHubLoading(value);
        }

        findHubById(hubId)
            .then(hub => {
                handleHubChanged(hub);
                handleHubLoadingChanged(false);
                return Promise.resolve();
            })
            .catch(error => {
                handleHubLoadingChanged(false);
                handleErrorCallback(error);
            });
    }, [hubId, handleErrorCallback]);

    return {
        hub,
        hubLoading
    };
}